/**
 * Hides the OOTB <hr> divider above External Providers.
 * Title visibility is handled by the widget override (CMS Title field), not here.
 */
import { signInExternalProvidersStyles as styles } from "@insite/content-library/Widgets/SignIn/SignInExternalProviders";
import { css } from "styled-components";

styles.divider = {
    css: css`
        display: none;
        margin: 0;
        border: none;
    `,
};
